module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-date-cf35bbf6.svg";